import { render } from "./ChooseStation.vue?vue&type=template&id=5d0c70d6&scoped=true"
import script from "./ChooseStation.vue?vue&type=script&lang=js"
export * from "./ChooseStation.vue?vue&type=script&lang=js"

import "./ChooseStation.vue?vue&type=style&index=0&id=5d0c70d6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/staging_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0c70d6"]])

export default __exports__